<template>
  <div class="comparison__card">
    <h3 class="comparison__card-title">{{ title }}</h3>
    <p class="comparison__card-text">{{ text }}</p>
    <router-link :to="to" class="comparison__card-link" :aria-label="ariaLabel">
      Read more
      <img src="@/images/arrow-read-more.svg" alt="" />
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    to: {
      type: [String, Object],
      required: true,
    },
    ariaLabel: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.comparison__card {
  flex: 1 1 352px;
  max-width: 392px;
  min-width: 352px;
  display: flex;
  flex-direction: column;
  padding: 24px;
  border-radius: 12px;
  border: 1px solid rgba(41, 44, 46, 0.2);
}

.comparison__card-title {
  font-size: 20px;
  font-weight: 600;
  line-height: 22px;
  color: #17191d;
  margin-bottom: 16px;
  min-height: 44px;
}

.comparison__card-text {
  font-family: "Avenir", Helvetica, Arial;
  color: #3d3d3d;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 40px;
}

.comparison__card-link {
  padding: 13px 25px;
  font-family: "Avenir", Helvetica, Arial;
  color: #7693fc;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  border: 1px solid #7693fc;
  background: #fff;
  margin-top: auto;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
}

.comparison__card-link:hover {
  opacity: 0.8;
}

@media screen and (max-width: 768px) {
  .comparison__card {
    flex-basis: auto;
    padding: 16px;
    width: 100%;
    max-width: none;
    min-width: 0;
  }

  .comparison__card-title {
    margin-bottom: 12px;
    min-height: auto;
  }

  .comparison__card-text {
    margin-bottom: 24px;
  }
}
</style>
